import { render } from "./DeleteIntent.vue?vue&type=template&id=596126e1&scoped=true"
import script from "./DeleteIntent.vue?vue&type=script&lang=js"
export * from "./DeleteIntent.vue?vue&type=script&lang=js"

import "./DeleteIntent.vue?vue&type=style&index=0&id=596126e1&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-596126e1"]])

export default __exports__